/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import TOC from '@ember/component/template-only';

export interface IPriorityFilterDefinitionArgs {}

const FiltersPriorityFilterComponent = TOC<IPriorityFilterDefinitionArgs>();

export default FiltersPriorityFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::PriorityFilter': typeof FiltersPriorityFilterComponent;
    'filters/priority-filter': typeof FiltersPriorityFilterComponent;
  }
}
